export const formatMobilePhone = (value) => {
  const numbersOnly = value.replace(/\D/g, "");
  if (numbersOnly.length < 4) return numbersOnly;
  if (numbersOnly.length < 8) return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`;
  if (numbersOnly.length <= 11) return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 7)}-${numbersOnly.slice(7)}`;
  return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 7)}-${numbersOnly.slice(7, 11)}`;
};

export const formatOfficePhone = (value) => {
  const numbersOnly = value.replace(/\D/g, "");
  if (numbersOnly.length < 4) return numbersOnly;
  if (numbersOnly.length < 7) return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`;
  if (numbersOnly.length <= 10) return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 6)}-${numbersOnly.slice(6)}`;
  return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 6)}-${numbersOnly.slice(6, 10)}`;
};
